import { criterionSeedFunc } from 'src/app/components/view-config-modal/view-config-modal.component';
import { ViewCriteriaModel, Criterion } from 'src/app/interfaces/views.interface';
import { ObjectSet } from 'src/app/utils/object-set/object-set.utils';

/**
 * Converts a ViewCriteriaModel array into a Map of product -> key - > value
 * @param viewCriteria - ViewCriteriaModel object to be converted into a Map of product -> key - > value
 */
export function viewCriteriaModelArrayToMap(viewCriteria: ViewCriteriaModel[]): ObjectSet<Criterion> {
	const criteriaSet: ObjectSet<Criterion> = new ObjectSet(criterionSeedFunc);
	viewCriteria.forEach(criteria => {
		if (!criteria.metadata) {
			// If there is no metadata, add the product with null key and null value
			criteriaSet.add({ product: criteria.product, key: null, value: null });
		}
		criteria.metadata?.forEach(metadata => {
			metadata.values.forEach(value => {
				// Add value
				criteriaSet.add({ product: criteria.product, key: metadata.key, value });
			});
		});
	});
	return criteriaSet;
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
